<template>
  <section class="section">
    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <date-picker
            v-model="date"
            type="month"
            :label="$t('form.selectMonth')"
            @dateChanged="getCurrentMonth"
          ></date-picker>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <add-transaction></add-transaction>
        </div>
      </div>
    </div>
    <category-amount-table
      :categories="amountsPerCategoryIncome"
      :total="totalIncome"
      :loading="loading"
      type="income"
    ></category-amount-table>
    <category-amount-table
      :categories="amountsPerCategoryExpense"
      :total="-totalExpense"
      :loading="loading"
      type="expense"
    ></category-amount-table>
    <totals-table :totals="totals" :loading="loading"></totals-table>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import CategoryAmountTable from "@/components/tables/CategoryAmountTable.vue";
import AddTransaction from "@/components/AddTransaction.vue";
import TotalsTable from "@/components/tables/TotalsTable.vue";
import DatePicker from "@/components/DatePicker.vue";

export default {
  components: {
    CategoryAmountTable,
    TotalsTable,
    AddTransaction,
    DatePicker
  },
  data() {
    return {
      loading: true,
      date: new Date(),
      chartOptions: {}
    };
  },
  created() {
    this.getCurrentMonth();
    this.getCategories();
  },
  methods: {
    getCurrentMonth() {
      this.loading = true;
      this.$store
        .dispatch("transactions/getMonthTransactions", this.date)
        .then(() => {
          this.loading = false;
        });
    },
    getCategories() {
      // TODO move to transactionModal
      this.$store.dispatch("categories/getCategories");
      // .then(this.showValidTransactionEdit);
    }
  },
  computed: {
    ...mapGetters("transactions", [
      "transactionsIncome",
      "transactionsExpense",
      "totalExpense",
      "totalIncome"
    ]),
    amountsPerCategoryIncome() {
      let amountsPerCategory = {};
      this.transactionsIncome.forEach((transaction) => {
        if (!amountsPerCategory[transaction.category]) {
          amountsPerCategory[transaction.category] = 0;
        }
        amountsPerCategory[transaction.category] += transaction.amount;
      });

      let data = [];
      Object.keys(amountsPerCategory).forEach((key) => {
        data.push({ category: key, amount: amountsPerCategory[key] });
      });
      return data;
    },
    amountsPerCategoryExpense() {
      let amountsPerCategory = {};
      this.transactionsExpense.forEach((transaction) => {
        if (!amountsPerCategory[transaction.category]) {
          amountsPerCategory[transaction.category] = 0;
        }
        amountsPerCategory[transaction.category] += transaction.amount;
      });

      let data = [];
      Object.keys(amountsPerCategory).forEach((key) => {
        data.push({ category: key, amount: amountsPerCategory[key] });
      });
      return data;
    },
    totals() {
      return [
        { name: "Income", amount: this.totalIncome },
        { name: "Expense", amount: this.totalExpense }
      ];
    }
  },
  beforeCreate() {
    document.body.classList.remove("radiant-background");
  }
};
</script>
